export default function Car() {
  const pathStyle = {
    stroke: 'none',
    strokeWidth: 1,
    strokeDasharray: 'none',
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    isCustomFont: 'none',
    fontFileUrl: 'none',
    fill: 'rgb(255, 255, 255)',
    opacity: 1,
  };
  return (
    <svg version="1.0" className="w-6 h-6" xmlns="http://www.w3.org/2000/svg"
 width="1000.000000pt" height="1000.000000pt" viewBox="0 0 1000.000000 1000.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,1000.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path style={pathStyle} d="M4199 7929 c-513 -31 -901 -262 -1206 -719 -143 -215 -252 -451 -424
-922 l-124 -337 -550 -3 c-616 -4 -598 -2 -752 -79 -175 -88 -303 -249 -354
-446 -18 -73 -19 -118 -19 -1003 0 -895 1 -930 20 -1006 63 -249 254 -442 498
-505 68 -17 112 -19 463 -19 l387 0 7 -32 c10 -46 56 -144 104 -223 118 -194
286 -336 491 -414 215 -83 450 -88 670 -14 276 92 522 337 615 613 l22 65
1023 0 1024 0 23 -64 c32 -88 93 -199 159 -286 125 -167 314 -291 533 -349
186 -50 366 -42 565 25 268 90 505 324 606 599 l28 75 453 5 454 5 73 27 c109
40 177 84 267 173 89 88 137 169 177 295 l23 75 0 950 c0 886 -1 954 -18 1014
-68 239 -239 417 -472 492 -60 19 -99 23 -275 27 l-205 4 -104 287 c-117 319
-203 528 -292 704 -204 406 -458 683 -764 833 -204 100 -361 139 -615 154
-183 11 -2328 10 -2511 -1z m1351 -1269 l0 -710 -1251 0 c-1188 0 -1251 1
-1244 18 4 9 37 101 75 203 159 433 297 700 458 884 155 177 337 273 578 304
38 5 365 9 727 10 l657 1 0 -710z m1200 699 c166 -20 281 -59 402 -136 194
-124 372 -377 538 -768 35 -81 190 -492 190 -502 0 -2 -396 -3 -880 -3 l-880
0 0 710 0 710 273 0 c150 0 311 -5 357 -11z m2098 -2013 l37 -34 3 -200 3
-200 -258 -4 c-257 -4 -258 -4 -315 -31 -102 -50 -157 -136 -158 -248 0 -112
42 -193 132 -250 l52 -34 273 -3 273 -3 0 -398 c0 -398 0 -398 -23 -432 -12
-19 -36 -38 -53 -44 -19 -6 -180 -9 -422 -7 l-391 2 -16 53 c-54 166 -188 353
-330 460 -202 153 -394 214 -648 205 -196 -8 -347 -57 -509 -166 -170 -115
-321 -312 -382 -499 l-18 -53 -1027 0 -1028 0 -12 43 c-40 132 -157 316 -266
416 -130 118 -319 215 -481 246 -43 8 -132 15 -196 15 -275 0 -516 -103 -702
-300 -115 -123 -189 -240 -230 -367 l-18 -53 -365 0 -365 0 -34 34 -34 34 0
406 0 406 273 0 c252 0 275 2 317 21 55 25 114 80 143 134 31 58 31 193 0 251
-31 59 -79 103 -143 133 -54 25 -60 26 -322 29 l-268 4 0 194 c0 212 4 229 59
259 22 12 552 14 3719 15 l3692 0 38 -34z m-5547 -1578 c129 -48 264 -167 329
-290 52 -97 53 -109 17 -179 -26 -51 -31 -71 -30 -128 1 -64 29 -151 54 -167
17 -10 9 -39 -37 -131 -75 -152 -224 -277 -379 -317 -157 -40 -288 -27 -430
43 -94 47 -148 91 -210 172 -42 54 -100 163 -106 199 -2 8 9 39 25 68 48 95
45 201 -10 285 l-25 38 45 93 c75 155 211 274 376 328 84 28 290 20 381 -14z
m3954 2 c140 -54 263 -163 332 -295 51 -99 53 -111 26 -156 -53 -85 -54 -188
-3 -285 l30 -55 -23 -57 c-111 -272 -403 -435 -677 -378 -98 21 -225 84 -294
147 -65 59 -137 163 -167 242 l-21 56 21 27 c32 41 54 127 47 182 -4 26 -20
75 -37 109 l-30 62 35 73 c44 93 93 156 176 224 126 105 214 135 395 130 107
-2 141 -7 190 -26z"/>
</g>
</svg>
  );
}
